/**
 * Extracts passenger number from passenger ID for display purposes
 * Handles both NSK format (PAX_0) and NDC format (PAX1)
 */
export const getPassengerNumber = (passengerId: string, fallbackIndex: number): number => {
  return passengerId.includes('_')
    ? Number.parseInt(passengerId.split('_')[1]) + 1
    : Number.parseInt(passengerId.replaceAll(/\D/g, '')) || fallbackIndex + 1;
};
